import { MRT_Localization_ES } from "material-react-table/locales/es";
import { MRT_Localization_RU } from "material-react-table/locales/ru";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { MRT_Localization } from "material-react-table";
import { MRT_Localization_BN } from "../i18n/mrt/bn";
import { MRT_Localization_GU } from "../i18n/mrt/gu";
import { MRT_Localization_HI } from "../i18n/mrt/hi";
import { MRT_Localization_ML } from "../i18n/mrt/ml";
import { MRT_Localization_MR } from "../i18n/mrt/mr";
import { MRT_Localization_NE } from "../i18n/mrt/ne";
import { MRT_Localization_OR } from "../i18n/mrt/or";
import { MRT_Localization_PA } from "../i18n/mrt/pa";
import { MRT_Localization_TA } from "../i18n/mrt/ta";
import { Locale, useLocale } from "./useLocale";

const LANGUAGE_TO_TRANSLATION: Record<Locale, MRT_Localization> = {
  en: MRT_Localization_EN,
  bn: MRT_Localization_BN,
  es: MRT_Localization_ES,
  gu: MRT_Localization_GU,
  hi: MRT_Localization_HI,
  ml: MRT_Localization_ML,
  mr: MRT_Localization_MR,
  ne: MRT_Localization_NE,
  or: MRT_Localization_OR,
  pa: MRT_Localization_PA,
  ru: MRT_Localization_RU,
  ta: MRT_Localization_TA,
};

export const useTableTranslate = () => {
  const { locale } = useLocale();
  return {
    tableLocale: LANGUAGE_TO_TRANSLATION[locale] || MRT_Localization_EN,
  };
};
